import { render, staticRenderFns } from "./Audits.vue?vue&type=template&id=487509a2&scoped=true"
import script from "./Audits.vue?vue&type=script&lang=js"
export * from "./Audits.vue?vue&type=script&lang=js"
import style0 from "./Audits.vue?vue&type=style&index=0&id=487509a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487509a2",
  null
  
)

export default component.exports